import { AxiosResponse } from "axios";

export const downloadFile = (
  downloadFn: () => Promise<AxiosResponse>,
  fileName: string,
) =>
  downloadFn()
    .then((response) => response.data)
    .then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const id = "download";

      link.id = id;
      link.href = fileURL;
      link.download = fileName;

      link.click();

      // Revoke the object URL to free memory (download is already initiated)
      window.URL.revokeObjectURL(fileURL);

      const linkElement = document.getElementById(id);
      linkElement?.remove();
    });

export const openPdfInNewTab = (downloadFn: () => Promise<AxiosResponse>) => {
  downloadFn()
    .then((response) => response.data)
    .then((blob) => {
      const blobPdf = new Blob([blob], { type: "application/pdf" });
      const link = document.createElement("a");
      const id = "go-to-new-tab";
      const fileURL = window.URL.createObjectURL(blobPdf);

      link.id = id;
      link.href = fileURL;
      link.target = "_blank";

      link.click();

      const linkElement = document.getElementById(id);
      linkElement?.remove();

      // Delay revoking URL to allow new tab to load the PDF first
      setTimeout(() => {
        window.URL.revokeObjectURL(fileURL);
      }, 1000);
    });
};

export const downloadFileRepo = (
  downloadFn: () => Promise<AxiosResponse>,
  fileName: string,
) =>
  downloadFn()
    .then((response) => response.data)
    .then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const id = "download";
      link.id = id;
      link.href = fileURL;
      link.download = fileName;

      link.click();

      // Revoke the object URL to free memory (download is already initiated)
      window.URL.revokeObjectURL(fileURL);

      const linkElement = document.getElementById(id);
      linkElement?.remove();
    });